import defaultSchema from './default.schema';

export default {
  ...defaultSchema,
  title: 'user',
  type: 'object',
  properties: {
    login: {
      type: 'string',
      title: 'Login *',
      fieldRequired: true
    },
    profile: {
      type: 'object',
      title: 'Profil',
      properties: {
        type: {
          title: 'Typ konta',
          type: 'number',
          fieldRequired: true
        },
        firstName: {
          title: 'Imię',
          type: 'string',
          fieldRequired: true,
          maxLength: 500
        },
        lastName: {
          title: 'Nazwisko',
          type: 'string',
          fieldRequired: true,
          maxLength: 500
        },
        email: {
          title: 'Adres e-mail',
          type: 'string',
          format: 'email'
        },
        phoneNumber: {
          title: 'Numer telefonu',
          type: 'string',
          maxLength: 500
        },
        companyName: {
          title: 'Nazwa podmiotu',
          type: 'string',
          fieldRequired: true,
          maxLength: 500
        },
        companyPosition: {
          title: 'Stanowisko',
          type: 'string',
          maxLength: 500
        }
      }
    }
  }
};
